import { useEffect, useState } from "react";
import type { Firestore } from "firebase/firestore";
import { collection, getDocs, query, where } from "firebase/firestore";

export function useCustomerOrderNumbers(db: Firestore, customerId: string | null) {
  const [orderNumbers, setOrderNumbers] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!customerId) {
      setOrderNumbers([]);
      return;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const snap = await getDocs(
          query(collection(db, "itInventory"), where("customerId", "==", customerId))
        );
        const seen = new Set<string>();
        snap.docs.forEach((d) => {
          const order = String((d.data() as any)?.orderNumber || "").trim();
          if (order) seen.add(order);
        });
        const arr = Array.from(seen).sort((a, b) => a.localeCompare(b, "sv"));
        if (!cancelled) setOrderNumbers(arr);
      } catch (e) {
        if (!cancelled) setError(e instanceof Error ? e.message : String(e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [db, customerId]);

  return { orderNumbers, loading, error };
}
